interface Args {
  boralTel: string,
  isSmallScreen?: boolean,
}

export function getCallBoralText(args: Args) {
  const {
    boralTel,
    isSmallScreen = false,
  } = args
  if (!boralTel) {
    return `Call Boral`
  }
  if (isSmallScreen) {
    return `Call Boral`
  }
  return `Call Boral (${boralTel})`
}
